import React from 'react';
import { EditedDocument, CpsDocumentMetadata, CpsIndex } from '@cs-cms/types';

export interface FormRetryData {
  formType: 'new' | 'edit';
  metadata: CpsDocumentMetadata;
  retryIndex: CpsIndex;
  contentType: string;
  documentId?: string;
  fileUploadRequired: boolean;
}

type DocumentFormContextType = {
  openNewDocumentForm: () => void;
  openEditDocumentForm: (document: EditedDocument) => void;
  openRetryForm: (retryData: FormRetryData) => void;
  closeDocumentForm: () => void;
  isFormOpen: boolean;
  editedDocument: 'new' | EditedDocument | undefined;
  initialFormData?: {
    metadata?: CpsDocumentMetadata;
    contentType?: string;
  };
  isRetry: boolean;
  fileUploadRequired: boolean;
};

export const DocumentFormContext = React.createContext<DocumentFormContextType | undefined>(undefined);

export const useDocumentFormContext = () => {
  const context = React.useContext(DocumentFormContext);
  if (context === undefined) {
    throw new Error('useDocumentFormContext must be used within a DocumentFormProvider');
  }
  return context;
};
